import React from "react";

const WebsiteList = () => {
  return <h1>Website List</h1>;
};

export default WebsiteList;
